<template>
  <div class="container-fluid mt-2">
    <h2>Lieferscheine</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" @keyup="updateSearch()" id="search" v-model="search" type="text"/>
      </div>
    </div>
    <b-table @row-clicked="openDelivery" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(deliverDate)="data">
        {{ data.item.deliverdate }}
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import delivernotes from '@/modules/delivernotes.js'

export default {
  name: 'DeliveryNoteList',
  props:['customer'],
  data() {
    return {
      search: "",
      rows: [],
      fields: [
        {label:"Lieferschein",key:"map_id"},
        {label:"Kunde-Nr",key:"customer"},
        {label:"Auftrags-Nr",key:"order"},
        {label:"Erstellt",key:"created"},
        {label:"Lieferdatum",key:"deliverDate"},
      ]
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      delivernotes.list(function(data) {
        self.rows = data;
      })
    },
    updateSearch: function() {
      delivernotes.viewparams.search = this.search;
      this.fetchData();
    },
    openDelivery(item) {
      console.log(item);
      router.push({ name:'DeliveryNoteView',params: {noteid: item.map_id }});
    },
    prevPage: function() {
      if (delivernotes.viewparams.page > 1) {
        delivernotes.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        delivernotes.viewparams.page++;
        this.fetchData();
      }
    }
  }
}
</script>
